export const DEFAULT_OVERFLOW_LIMIT = 5;
export const DEFAULT_LOAD_DEBOUNCE = 300;
export const DEFAULT_STATIC_SEARCH_DEBOUNCE = 150;
export const DEFAULT_SEARCH_LIMIT = {
    MIN: 1000,
    MAX: 2147483647,
};
export const COMMA = ',';
export const INLINE_VALUE_DELIMITER = `${COMMA} `;
export const DEFAULT_TRANSLATIONS = {
    selection: 'Selection',
    selected: 'Selected',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    search: 'Search',
    total: 'Total',
    totalSeparator: 'of',
    toggleSelection: 'Toggle selection type',
    noEntries: 'There are no entries',
};
